import React, { useState, useEffect } from 'react';
import { Row, Col, Input, Tag, Checkbox, Button, Card } from 'antd';
import { remove } from 'lodash'
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { API } from 'aws-amplify';
import FiltersTable from '../../FiltersTable';
import * as custom_queries from "../../../../Custom_queries/queries";
import '../../../../styles/Dispositivos.css'
import {usePagination} from '../../../../hooks/useFiltersPagination.js';


const { Search } = Input;

const Dispositivos = (
  {
    marca,
    setMarca,
    tipo,
    setTipo,
    sistemaOperativo,
    setSistemaOperativo,
    gama,
    setGama,
    versionSO,
    setVersionSO,
    tecnologia,
    setTecnologia,
    tecNavegacion,
    setTecNavegacion,
  }
) => {
  const [selectedData1, setSelectedData1] = useState();
  const [selectedData2, setSelectedData2] = useState();
  const [selectedData3, setSelectedData3] = useState();
  const [selectedData4, setSelectedData4] = useState();
  const [selectedData5, setSelectedData5] = useState();
  const [selectedData6, setSelectedData6] = useState();
  const [selectedData7, setSelectedData7] = useState();
  const [searchValue1, setSearchValue1] = useState();
  const [searchValue2, setSearchValue2] = useState();
  const [searchValue3, setSearchValue3] = useState();
  const [searchValue4, setSearchValue4] = useState();
  const [searchValue5, setSearchValue5] = useState();
  const [searchValue6, setSearchValue6] = useState();
  const [searchValue7, setSearchValue7] = useState();
  const [showLoadingData1, setShowLoadingData1] = useState(false);
  const [showLoadingData2, setShowLoadingData2] = useState(false);
  const [showLoadingData3, setShowLoadingData3] = useState(false);
  const [showLoadingData4, setShowLoadingData4] = useState(false);
  const [showLoadingData5, setShowLoadingData5] = useState(false);
  const [showLoadingData6, setShowLoadingData6] = useState(false);
  const [showLoadingData7, setShowLoadingData7] = useState(false);
  const [selectedsData1, setSelectedsData1] = useState([]);
  const [selectedsData2, setSelectedsData2] = useState([]);
  const [selectedsData3, setSelectedsData3] = useState([]);
  const [selectedsData4, setSelectedsData4] = useState([]);
  const [selectedsData5, setSelectedsData5] = useState([]);
  const [selectedsData6, setSelectedsData6] = useState([]);
  const [selectedsData7, setSelectedsData7] = useState([]);
  const [banderaTags1, setBanderaTags1] = useState(false)
  const [banderaTags2, setBanderaTags2] = useState(false)
  const [banderaTags3, setBanderaTags3] = useState(false)
  const [banderaTags4, setBanderaTags4] = useState(false)
  const [banderaTags5, setBanderaTags5] = useState(false)
  const [banderaTags6, setBanderaTags6] = useState(false)
  const [banderaTags7, setBanderaTags7] = useState(false)


  const fetchFilter1 = async (filter = null) => {
    try {
      const response = await API.graphql({
        query: `query MyQuery {
          getFiltersRedshift(input: { query: "getBranchDevices", name_filter: "${filter}" }) {
            key
            description_filter
            type_filter
            value_filter
            id_statement
          }
        }`
      });
  
      const data = response.data.getFiltersRedshift.sort((a, b) => a.value_filter.localeCompare(b.value_filter));
  
      if (data[0].id_statement !== null) {
        await getValues({
          idStatement: data[0].id_statement,
          query: "getBranchDevices",
          setter: setSelectedData1,
          showLoading: setShowLoadingData1
        });
      } else {
        const newData = data.map(item => {
          const { id_statement, ...rest } = item;
          return rest;
        });
  
        setSelectedData1(newData.length > 0 && newData[0].value_filter !== "Sin Datos" ? newData : []);
        setShowLoadingData1(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle the error appropriately (e.g., show an error message)
    }
  };

  useEffect(() => {
    setShowLoadingData1(true);
    fetchFilter1(searchValue1);
  }, [searchValue1]);
  

  const fetchFilter2 = async (filter = null) => {
    try {
      const response = await API.graphql({
        query: `query MyQuery {
          getFiltersRedshift(input: { query: "getTypeDevices", name_filter: "${filter}" }) {
            key
            description_filter
            type_filter
            value_filter
            id_statement
          }
        }`
      });
  
      const data = response.data.getFiltersRedshift.sort((a, b) => a.value_filter.localeCompare(b.value_filter));;
  
      if (data[0].id_statement !== null) {
        await getValues({
          idStatement: data[0].id_statement,
          query: "getTypeDevices",
          setter: setSelectedData2,
          showLoading: setShowLoadingData2
        });
      } else {
        const newData = data.map(item => {
          const { id_statement, ...rest } = item;
          return rest;
        });
  
        setSelectedData2(newData.length > 0 && newData[0].value_filter !== "Sin Datos" ? newData : []);
        setShowLoadingData2(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle the error appropriately (e.g., show an error message)
    }
  };

  useEffect(() => {
    setShowLoadingData2(true);
    fetchFilter2(searchValue2);
  }, [searchValue2]);

  const fetchFilter3 = async (filter = null) => {
    try {
      const response = await API.graphql({
        query: `query MyQuery {
          getFiltersRedshift(input: { query: "getOsDevices", name_filter: "${filter}" }) {
            key
            description_filter
            type_filter
            value_filter
            id_statement
          }
        }`
      });
  
      const data = response.data.getFiltersRedshift.sort((a, b) => a.value_filter.localeCompare(b.value_filter));
  
      if (data[0].id_statement !== null) {
        await getValues({
          idStatement: data[0].id_statement,
          query: "getOsDevices",
          setter: setSelectedData3,
          showLoading: setShowLoadingData3
        });
      } else {
        const newData = data.map(item => {
          const { id_statement, ...rest } = item;
          return rest;
        });
  
        setSelectedData3(newData.length > 0 && newData[0].value_filter !== "Sin Datos" ? newData : []);
        setShowLoadingData3(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle the error appropriately (e.g., show an error message)
    }
  };

  useEffect(() => {
    setShowLoadingData3(true);
    fetchFilter3(searchValue3);
  }, [searchValue3]);

  useEffect(() => {
    setSelectedsData3(sistemaOperativo);
  }, [sistemaOperativo]);

  const fetchFilter4 = async (filter = null) => {
    try {
      const response = await API.graphql({
        query: `query MyQuery {
          getFiltersRedshift(input: { query: "getRangeDevices", name_filter: "${filter}" }) {
            key
            description_filter
            type_filter
            value_filter
            id_statement
          }
        }`
      });
  
      const data = response.data.getFiltersRedshift.sort((a, b) => a.value_filter.localeCompare(b.value_filter));
  
      if (data[0].id_statement !== null) {
        await getValues({
          idStatement: data[0].id_statement,
          query: "getRangeDevices",
          setter: setSelectedData4,
          showLoading: setShowLoadingData4
        });
      } else {
        const newData = data.map(item => {
          const { id_statement, ...rest } = item;
          return rest;
        });
  
        setSelectedData4(newData.length > 0 && newData[0].value_filter !== "Sin Datos" ? newData : []);
        setShowLoadingData4(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle the error appropriately (e.g., show an error message)
    }
  };

  useEffect(() => {
    setSelectedsData4(true);
    fetchFilter4(searchValue4);
  }, [searchValue4]);

    useEffect(() => {
      setSelectedsData4(gama);
    }, [gama]);

  const fetchFilter5 = async (filter = null) => {
    try {
      const response = await API.graphql({
        query: `query MyQuery {
          getFiltersRedshift(input: { query: "getOperatingSystemVersionCat", name_filter: "${filter}" }) {
            key
            description_filter
            type_filter
            value_filter
            id_statement
          }
        }`
      });
  
      const data = response.data.getFiltersRedshift.sort((a, b) => a.value_filter.localeCompare(b.value_filter));
  
      if (data[0].id_statement !== null) {
        await getValues({
          idStatement: data[0].id_statement,
          query: "getOperatingSystemVersionCat",
          setter: setSelectedData5,
          showLoading: setShowLoadingData5
        });
      } else {
        const newData = data.map(item => {
          const { id_statement, ...rest } = item;
          return rest;
        });
  
        setSelectedData5(newData.length > 0 && newData[0].value_filter !== "Sin Datos" ? newData : []);
        setShowLoadingData5(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle the error appropriately (e.g., show an error message)
    }
  };

  useEffect(() => {
    setSelectedsData5(true);
    fetchFilter5(searchValue5);
  }, [searchValue5]);

    useEffect(() => {
      setSelectedsData5(versionSO);
    }, [versionSO]);

  const fetchFilter6 = async (filter = null) => {
    try {
      const response = await API.graphql({
        query: `query MyQuery {
          getFiltersRedshift(input: { query: "getTechnologyTeam", name_filter: "${filter}" }) {
            key
            description_filter
            type_filter
            value_filter
            id_statement
          }
        }`
      });
  
      const data = response.data.getFiltersRedshift.sort((a, b) => a.value_filter.localeCompare(b.value_filter));
  
      if (data[0].id_statement !== null) {
        await getValues({
          idStatement: data[0].id_statement,
          query: "getTechnologyTeam",
          setter: setSelectedData6,
          showLoading: setShowLoadingData6
        });
      } else {
        const newData = data.map(item => {
          const { id_statement, ...rest } = item;
          return rest;
        });
  
        setSelectedData6(newData.length > 0 && newData[0].value_filter !== "Sin Datos" ? newData : []);
        setShowLoadingData6(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle the error appropriately (e.g., show an error message)
    }
  };

  useEffect(() => {
    setSelectedsData6(true);
    fetchFilter6(searchValue6);
  }, [searchValue6]);

    useEffect(() => {
      setSelectedsData6(tecnologia);
    }, [tecnologia]);

  const fetchFilter7 = async (filter = null) => {
    try {
      const response = await API.graphql({
        query: `query MyQuery {
          getFiltersRedshift(input: { query: "getTechnoNavigation", name_filter: "${filter}" }) {
            key
            description_filter
            type_filter
            value_filter
            id_statement
          }
        }`
      });
  
      const data = response.data.getFiltersRedshift.sort((a, b) => a.value_filter.localeCompare(b.value_filter));
  
      if (data[0].id_statement !== null) {
        await getValues({
          idStatement: data[0].id_statement,
          query: "getTechnoNavigation",
          setter: setSelectedData7,
          showLoading: setShowLoadingData7
        });
      } else {
        const newData = data.map(item => {
          const { id_statement, ...rest } = item;
          return rest;
        });
  
        setSelectedData7(newData.length > 0 && newData[0].value_filter !== "Sin Datos" ? newData : []);
        setShowLoadingData7(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle the error appropriately (e.g., show an error message)
    }
  };

  useEffect(() => {
    setSelectedsData7(true);
    fetchFilter7(searchValue7);
  }, [searchValue7]);

    useEffect(() => {
      setSelectedsData7(tecNavegacion);
    }, [tecNavegacion]);

  const getValues = async ({ idStatement, query, setter, showLoading }) => {
    let response = [];
    while (response.length === 0) {
      const result = await API.graphql({
        query: `query MyQuery {
          getData(input: {id_statement: "${idStatement}", query: "${query}" }) {
            key
            description_filter
            type_filter
            value_filter
          }
        }`
      });
      response = result.data.getData;

      if (response.length === 0) {
        await new Promise(resolve => setTimeout(resolve, 5000)); // Esperar 5 segundos antes de hacer la siguiente petición
      }
    }
    setter(response.length > 0 && response[0].value_filter !== "Sin Datos" ? response : [])
    showLoading(false)
  };

  useEffect(() => {
    if (marca.length === 0) {
      setSelectedsData1([]);
      setBanderaTags1(false);
    }
  }, [marca]);
  
  useEffect(() => {
    if (tipo.length === 0) {
      setSelectedsData2([]);
      setBanderaTags2(false);
    }
  }, [tipo]);
  
  useEffect(() => {
    if (sistemaOperativo.length === 0) {
      setSelectedsData3([]);
      setBanderaTags3(false);
    }
  }, [sistemaOperativo]);
  
  useEffect(() => {
    if (gama.length === 0) {
      setSelectedsData4([]);
      setBanderaTags4(false);
    }
  }, [gama]);

  useEffect(() => {
    if (versionSO.length === 0) {
      setSelectedsData5([]);
      setBanderaTags5(false);
    }
  }, [versionSO]);

  useEffect(() => {
    if (tecnologia.length === 0) {
      setSelectedsData6([]);
      setBanderaTags6(false);
    }
  }, [tecnologia]);

  useEffect(() => {
    if (tecNavegacion.length === 0) {
      setSelectedsData7([]);
      setBanderaTags7(false);
    }
  }, [tecNavegacion]);

  const filters = [
    {
      title: "Marca",
      selectedData: selectedData1,
      setSelectedData: setSelectedData1,
      selectedsData: selectedsData1,
      setSelectedsData: setSelectedsData1,
      filterComponent: marca,
      setFilterComponent: setMarca,
      banderaTags: banderaTags1,
      setBanderaTags: setBanderaTags1,
      showLoadingData: showLoadingData1, 
      setShowLoadingData: setShowLoadingData1, 
    },
    {
      title: "Tipo",
      selectedData: selectedData2,
      setSelectedData: setSelectedData2,
      selectedsData: selectedsData2,
      setSelectedsData: setSelectedsData2,
      filterComponent: tipo,
      setFilterComponent: setTipo,
      banderaTags: banderaTags2,
      setBanderaTags: setBanderaTags2,
      showLoadingData: showLoadingData2, 
      setShowLoadingData: setShowLoadingData2, 
    },
    {
      title: "Sistema Operativo",
      selectedData: selectedData3,
      setSelectedData: setSelectedData3,
      selectedsData: selectedsData3,
      setSelectedsData: setSelectedsData3,
      filterComponent: sistemaOperativo,
      setFilterComponent: setSistemaOperativo,
      banderaTags: banderaTags3,
      setBanderaTags: setBanderaTags3,
      showLoadingData: showLoadingData3, 
      setShowLoadingData: setShowLoadingData3, 
    },
    {
      title: "Gama",
      selectedData: selectedData4,
      setSelectedData: setSelectedData4,
      selectedsData: selectedsData4,
      setSelectedsData: setSelectedsData4,
      filterComponent: gama,
      setFilterComponent: setGama,
      banderaTags: banderaTags4,
      setBanderaTags: setBanderaTags4,
      showLoadingData: showLoadingData4, 
      setShowLoadingData: setShowLoadingData4, 
    },
    {
      title: "Versión sistema operativo",
      selectedData: selectedData5,
      setSelectedData: setSelectedData5,
      selectedsData: selectedsData5,
      setSelectedsData: setSelectedsData5,
      filterComponent: versionSO,
      setFilterComponent: setVersionSO,
      banderaTags: banderaTags5,
      setBanderaTags: setBanderaTags5,
      showLoadingData: showLoadingData5, 
      setShowLoadingData: setShowLoadingData5, 
    },
    {
      title: "Tecnología del equipo",
      selectedData: selectedData6,
      setSelectedData: setSelectedData6,
      selectedsData: selectedsData6,
      setSelectedsData: setSelectedsData6,
      filterComponent: tecnologia,
      setFilterComponent: setTecnologia,
      banderaTags: banderaTags6,
      setBanderaTags: setBanderaTags6,
      showLoadingData: showLoadingData6, 
      setShowLoadingData: setShowLoadingData6, 
    },
    {
      title: "Máxima tecnología de navegación",
      selectedData: selectedData7,
      setSelectedData: setSelectedData7,
      selectedsData: selectedsData7,
      setSelectedsData: setSelectedsData7,
      filterComponent: tecNavegacion,
      setFilterComponent: setTecNavegacion,
      banderaTags: banderaTags7,
      setBanderaTags: setBanderaTags7,
      showLoadingData: showLoadingData7, 
      setShowLoadingData: setShowLoadingData7, 
    },
  ];

  const {
    currentPage,
    handleNext,
    handlePrev,
    visibleItems: visibleFilters,
    endIndex,
  } = usePagination(filters);

  return (
    <Row className="DemograficosColumns" gutter={16}>
      <Col span={12}>
        <Row gutter={[16, 24]}>
          {visibleFilters.map((filter, index) => (
            <Col span={12} key={index}>
              <h3>{filter.title}</h3>
              <FiltersTable
                selectedData={filter.selectedData}
                setSelectedData={filter.setSelectedData}
                selectedsData={filter.selectedsData}
                setSelectedsData={filter.setSelectedsData}
                filterComponent={filter.filterComponent}
                setFilterComponent={filter.setFilterComponent}
                banderaTags={filter.banderaTags}
                setBanderaTags={filter.setBanderaTags}
                showLoadingData={filter.showLoadingData}
                setShowLoadingData={filter.setShowLoadingData}
              />
            </Col>
          ))}
        </Row>
        {filters.length > 2 && (
          <Row style={{ marginTop: '20px', justifyContent: 'center' }}>
            <div style={{ display: 'flex', gap: '16px' }}>
              <Button
                className="navigation-button"
                shape="circle"
                icon={<LeftOutlined />}
                onClick={handlePrev}
                disabled={currentPage === 0}
              />
              <Button
                className="navigation-button"
                shape="circle"
                icon={<RightOutlined />}
                onClick={handleNext}
                disabled={endIndex >= filters.length}
              />
            </div>
          </Row>
        )}
      </Col>
      <Col span={12} >
        <Row gutter={[16, 16]} style={{ justifyContent: 'flex-end' }}> 
          <Card
              style={{
                width: 500,
                height: 300,
                marginTop: 20,
                overflow: 'auto',
                borderRadius: 15, 
              }}
            >
            {selectedsData1 && selectedsData1.map(({ key, value_filter }) => (
              <Tag
                key={key}
                className="TagsSelectFilters"
                closable
                onClose={e => {
                  const updatedSelecteds = selectedsData1.filter(item => item.key !== key);
                  setSelectedsData1(updatedSelecteds);
                  setMarca(updatedSelecteds); 
                  setBanderaTags1(true);
                }}
              >
                {value_filter}
              </Tag>
            ))}
            {selectedsData2 && selectedsData2.map(({ key, value_filter }) => (
              <Tag
                key={key}
                className="TagsSelectFilters"
                closable
                onClose={e => {
                  const updatedSelecteds = selectedsData2.filter(item => item.key !== key);
                  setSelectedsData2(updatedSelecteds);
                  setTipo(updatedSelecteds); 
                  setBanderaTags2(true);
                }}
              >
                {value_filter}
              </Tag>
            ))}
            {selectedsData3 && selectedsData3.map(({ key, value_filter }) => (
              <Tag
                key={key}
                className="TagsSelectFilters"
                closable
                onClose={e => {
                  const updatedSelecteds = selectedsData3.filter(item => item.key !== key);
                  setSelectedsData3(updatedSelecteds);
                  setSistemaOperativo(updatedSelecteds); 
                  setBanderaTags3(true);
                }}
              >
                {value_filter}
              </Tag>
            ))}
            {selectedsData4 && selectedsData4.map(({ key, value_filter }) => (
              <Tag
                key={key}
                className="TagsSelectFilters"
                closable
                onClose={e => {
                  const updatedSelecteds = selectedsData4.filter(item => item.key !== key);
                  setSelectedsData4(updatedSelecteds);
                  setGama(updatedSelecteds); 
                  setBanderaTags4(true);
                }}
              >
                {value_filter}
              </Tag>
            ))}
            {selectedsData5 && selectedsData5.map(({ key, value_filter }) => (
              <Tag
                key={key}
                className="TagsSelectFilters"
                closable
                onClose={e => {
                  const updatedSelecteds = selectedsData5.filter(item => item.key !== key);
                  setSelectedsData5(updatedSelecteds);
                  setVersionSO(updatedSelecteds); 
                  setBanderaTags5(true);
                }}
              >
                {value_filter}
              </Tag>
            ))}
            {selectedsData6 && selectedsData6.map(({ key, value_filter }) => (
              <Tag
                key={key}
                className="TagsSelectFilters"
                closable
                onClose={e => {
                  const updatedSelecteds = selectedsData6.filter(item => item.key !== key);
                  setSelectedsData6(updatedSelecteds);
                  setTecnologia(updatedSelecteds); 
                  setBanderaTags6(true);
                }}
              >
                {value_filter}
              </Tag>
            ))}
            {selectedsData7 && selectedsData7.map(({ key, value_filter }) => (
              <Tag
                key={key}
                className="TagsSelectFilters"
                closable
                onClose={e => {
                  const updatedSelecteds = selectedsData7.filter(item => item.key !== key);
                  setSelectedsData7(updatedSelecteds);
                  setTecNavegacion(updatedSelecteds); 
                  setBanderaTags7(true);
                }}
              >
                {value_filter}
              </Tag>
            ))}
          </Card>
        </Row>
      </Col>
    </Row>
  );
}
export default Dispositivos;
